import { Api } from "./Api";


let EmployerApi = {
    endpoint: "Employers/",

}

//Add the Api Mixin
EmployerApi = Object.assign({}, Api, EmployerApi);

export { EmployerApi };
